import { useState, useMemo } from 'react';
import { useApp } from '../../contexts/AppContext';
import { checkoutsService } from '../../services/checkouts.service';
import { assetsService } from '../../services/assets.service';

const STATUS_COLOR = { Available:'#00e5a0','In Use':'#5b9cf6','Out':'#f5a623',Returned:'#00e5a0' };
function Chip({ label }) { const c=STATUS_COLOR[label]||'#607080'; return <span style={{ background:c+'18',border:`1px solid ${c}30`,color:c,borderRadius:6,padding:'2px 9px',fontSize:11,fontWeight:700 }}>{label}</span>; }
function Lbl({ children }) { return <div style={{ fontSize:10,color:'#3a5060',textTransform:'uppercase',letterSpacing:'1px',fontWeight:600,marginBottom:6 }}>{children}</div>; }
function Modal({ title, sub, onClose, children }) {
  return <div style={{ position:'fixed',inset:0,background:'rgba(0,0,0,.88)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }} onClick={e=>e.target===e.currentTarget&&onClose()}>
    <div style={{ background:'#090e15',border:'1px solid #1a2a3a',borderRadius:14,width:'100%',maxWidth:640,maxHeight:'90vh',overflow:'hidden',display:'flex',flexDirection:'column' }}>
      <div style={{ padding:'20px 24px',borderBottom:'1px solid #1a2a3a' }}>
        <div style={{ fontFamily:"'Syne',sans-serif",fontSize:16,fontWeight:800,color:'#e8edf2' }}>{title}</div>
        {sub&&<div style={{ fontSize:11,color:'#3a5060',marginTop:3,fontFamily:"'IBM Plex Mono',monospace" }}>{sub}</div>}
      </div>
      <div style={{ padding:24,overflowY:'auto' }}>{children}</div>
    </div>
  </div>;
}

export default function CheckoutPage() {
  const { assets, setAssets, checkouts, setCheckouts, profile, perms, showToast } = useApp();
  const [tab,setTab]               = useState('checkout');
  const [search,setSearch]         = useState('');
  const [modal,setModal]           = useState(null);
  const [form,setForm]             = useState({});
  const [returnModal,setReturnModal] = useState(null);
  const [saving,setSaving]         = useState(false);

  const availableAssets = useMemo(()=>{
    const q=search.toLowerCase();
    return assets.filter(a=>a.status==='Available'&&(q===''||a.name?.toLowerCase().includes(q)||a.inventoryNumber?.toLowerCase().includes(q)||a.epc?.toLowerCase().includes(q)));
  },[assets,search]);

  const activeCheckouts = useMemo(()=>checkouts.filter(c=>c.status==='Out'),[checkouts]);
  const history         = useMemo(()=>checkouts.filter(c=>c.status==='Returned'),[checkouts]);

  const doCheckout = async () => {
    if(!form.checked_out_to) return;
    setSaving(true);
    try {
      const record = await checkoutsService.create({ ...form, checked_out_by: profile?.name, checked_out_by_id: profile?.id, status:'Out' });
      await assetsService.update(form.asset_id, { status:'In Use', checked_out_by:profile?.name, checked_out_to:form.checked_out_to });
      setCheckouts(prev=>[record,...prev]);
      setAssets(prev=>prev.map(a=>a.id===form.asset_id?{...a,status:'In Use',checked_out_by:profile?.name,checked_out_to:form.checked_out_to}:a));
      showToast('✓ Asset checked out');
      setModal(null); setSearch('');
    } catch(err){ showToast('❌ '+err.message,'error'); }
    setSaving(false);
  };

  const doReturn = async (checkout) => {
    setSaving(true);
    try {
      await checkoutsService.update(checkout.id, { status:'Returned', returned_at: new Date().toISOString() });
      await assetsService.update(checkout.asset_id, { status:'Available', checked_out_by:'', checked_out_to:'' });
      setCheckouts(prev=>prev.map(c=>c.id===checkout.id?{...c,status:'Returned',returned_at:new Date().toISOString()}:c));
      setAssets(prev=>prev.map(a=>a.id===checkout.asset_id?{...a,status:'Available',checked_out_by:'',checked_out_to:''}:a));
      showToast('✓ Asset returned');
      setReturnModal(null);
    } catch(err){ showToast('❌ '+err.message,'error'); }
    setSaving(false);
  };

  const TABS = [{ id:'checkout',label:'Check Out Asset',count:null },{ id:'active',label:'Currently Out',count:activeCheckouts.length },{ id:'history',label:'Return History',count:null }];

  return <div>
    <div style={{ marginBottom:24 }}>
      <div style={{ fontFamily:"'Syne',sans-serif",fontSize:22,fontWeight:800,color:'#e8edf2' }}>Asset Check-In / Check-Out</div>
      <div style={{ fontSize:12,color:'#3a5060',marginTop:4 }}>Track who has which asset and when it was taken</div>
    </div>
    <div style={{ display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:14,marginBottom:24 }}>
      {[{label:'Currently Out',value:activeCheckouts.length,sub:'Assets checked out',icon:'📤',c:'#f5a623'},{label:'Available',value:assets.filter(a=>a.status==='Available').length,sub:'Ready to check out',icon:'✅',c:'#00e5a0'},{label:'Total Checkouts',value:checkouts.length,sub:'All time',icon:'📋',c:'#5b9cf6'}].map(s=>(
        <div key={s.label} style={{ background:'#0d1520',border:'1px solid #1a2a3a',borderRadius:12,padding:20 }}>
          <div style={{ display:'flex',alignItems:'center',gap:10,marginBottom:10 }}>
            <div style={{ width:36,height:36,borderRadius:9,background:s.c+'18',border:`1px solid ${s.c}30`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:18 }}>{s.icon}</div>
            <div style={{ fontSize:10,color:'#3a5060',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.6px' }}>{s.label}</div>
          </div>
          <div style={{ fontSize:28,fontWeight:800,color:'#e8edf2',fontFamily:"'Syne',sans-serif" }}>{s.value}</div>
          <div style={{ fontSize:11,color:'#607080',marginTop:4 }}>{s.sub}</div>
        </div>
      ))}
    </div>

    <div style={{ display:'flex',gap:2,borderBottom:'1px solid #1a2a3a',marginBottom:20 }}>
      {TABS.map(t=><button key={t.id} className="tab-btn" onClick={()=>setTab(t.id)} style={{ color:tab===t.id?'#00e5a0':'#3a5060',borderBottom:tab===t.id?'2px solid #00e5a0':'2px solid transparent' }}>
        {t.label}{t.count!==null&&<span style={{ marginLeft:6,background:'#1a2a3a',borderRadius:10,padding:'1px 7px',fontSize:10,color:'#607080' }}>{t.count}</span>}
      </button>)}
    </div>

    {tab==='checkout'&&<>
      {!perms.canCheckout
        ? <div style={{ textAlign:'center',padding:'60px 0',color:'#3a5060' }}><div style={{ fontSize:32,marginBottom:12 }}>🔒</div><div>You don't have permission to check out assets.</div></div>
        : <>
          <div style={{ position:'relative',marginBottom:18 }}>
            <span style={{ position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',color:'#3a5060' }}>🔍</span>
            <input className="inp" style={{ paddingLeft:34 }} placeholder="Search by asset name, inventory number, EPC…" value={search} onChange={e=>setSearch(e.target.value)} />
          </div>
          {availableAssets.length===0
            ? <div style={{ textAlign:'center',padding:'40px 0',color:'#3a5060' }}>{search?'No available assets match your search':'No available assets found'}</div>
            : <div style={{ display:'grid',gap:10 }}>
                  {availableAssets.map(a=>(
                    <div key={a.id} style={{ background:'#0d1520',border:'1px solid #1a2a3a',borderRadius:10,padding:'14px 18px',display:'flex',alignItems:'center',gap:16 }}>
                      <div style={{ flex:1 }}>
                        <div style={{ fontWeight:700,fontSize:14,color:'#e8edf2',marginBottom:4 }}>{a.name}</div>
                        <div style={{ display:'flex',gap:14,fontSize:11,color:'#3a5060' }}>
                          <span style={{ fontFamily:"'IBM Plex Mono',monospace",color:'#f5a623' }}>{a.inventoryNumber}</span>
                          <span>{a.type}</span><span>{a.currentFacilityName}</span>
                        </div>
                      </div>
                      <Chip label="Available"/>
                      <button className="btn" style={{ background:'#00e5a0',color:'#060b10',padding:'8px 16px',fontSize:12 }}
                        onClick={()=>{setForm({asset_id:a.id,asset_name:a.name,inventory_number:a.inventoryNumber,epc:a.epc,checked_out_to:'',expected_return:'',notes:'',facility_id:a.currentFacility,facility_name:a.currentFacilityName});setModal('checkout');}}>
                        Check Out
                      </button>
                    </div>
                  ))}
                </div>}
        </>}
    </>}

    {tab==='active'&&<div style={{ background:'#0d1520',border:'1px solid #1a2a3a',borderRadius:12,overflow:'hidden' }}>
      <table style={{ width:'100%',borderCollapse:'collapse' }}>
        <thead><tr style={{ borderBottom:'1px solid #1a2a3a' }}>
          {['Record ID','Inventory No','Asset','Checked Out By','Purpose','Facility','Checked Out','Status','Action'].map(h=><th key={h} className="th">{h}</th>)}
        </tr></thead>
        <tbody>
          {activeCheckouts.length===0&&<tr><td colSpan={9} style={{ textAlign:'center',padding:'40px 0',color:'#3a5060' }}>No assets currently checked out</td></tr>}
          {activeCheckouts.map((c,i)=><tr key={c.id} style={{ borderBottom:i<activeCheckouts.length-1?'1px solid #0d1520':'none' }}>
            <td className="td"><span style={{ fontFamily:"'IBM Plex Mono',monospace",fontSize:11,color:'#5b9cf6' }}>{c.id?.slice(0,8)}</span></td>
            <td className="td"><span style={{ fontFamily:"'IBM Plex Mono',monospace",fontSize:11,color:'#f5a623' }}>{c.inventory_number}</span></td>
            <td className="td"><span style={{ fontWeight:600,color:'#e8edf2' }}>{c.asset_name}</span></td>
            <td className="td"><span style={{ fontSize:12 }}>{c.checked_out_by}</span></td>
            <td className="td"><span style={{ fontSize:12,color:'#c8d6e0' }}>{c.checked_out_to}</span></td>
            <td className="td"><span style={{ fontSize:12,color:'#607080' }}>{c.facility_name}</span></td>
            <td className="td"><span style={{ fontFamily:"'IBM Plex Mono',monospace",fontSize:11,color:'#3a5060' }}>{c.checked_out_at?.slice(0,16)}</span></td>
            <td className="td"><Chip label={c.status}/></td>
            <td className="td">{perms.canCheckout&&<button className="btn" style={{ background:'#5b9cf620',border:'1px solid #5b9cf640',color:'#5b9cf6',padding:'5px 12px',fontSize:11 }} onClick={e=>{e.stopPropagation();setReturnModal(c);}}>↩ Return</button>}</td>
          </tr>)}
        </tbody>
      </table>
    </div>}

    {tab==='history'&&<div style={{ background:'#0d1520',border:'1px solid #1a2a3a',borderRadius:12,overflow:'hidden' }}>
      <table style={{ width:'100%',borderCollapse:'collapse' }}>
        <thead><tr style={{ borderBottom:'1px solid #1a2a3a' }}>
          {['Record ID','Inventory No','Asset','By','Purpose','Checked Out','Returned','Status'].map(h=><th key={h} className="th">{h}</th>)}
        </tr></thead>
        <tbody>
          {history.length===0&&<tr><td colSpan={8} style={{ textAlign:'center',padding:'40px 0',color:'#3a5060' }}>No return history yet</td></tr>}
          {history.map((c,i)=><tr key={c.id} style={{ borderBottom:i<history.length-1?'1px solid #0d1520':'none' }}>
            <td className="td"><span style={{ fontFamily:"'IBM Plex Mono',monospace",fontSize:11,color:'#5b9cf6' }}>{c.id?.slice(0,8)}</span></td>
            <td className="td"><span style={{ fontFamily:"'IBM Plex Mono',monospace",fontSize:11,color:'#f5a623' }}>{c.inventory_number}</span></td>
            <td className="td"><span style={{ fontWeight:600,color:'#e8edf2' }}>{c.asset_name}</span></td>
            <td className="td"><span style={{ fontSize:12 }}>{c.checked_out_by}</span></td>
            <td className="td"><span style={{ fontSize:12,color:'#c8d6e0' }}>{c.checked_out_to}</span></td>
            <td className="td"><span style={{ fontFamily:"'IBM Plex Mono',monospace",fontSize:11,color:'#3a5060' }}>{c.checked_out_at?.slice(0,16)}</span></td>
            <td className="td"><span style={{ fontFamily:"'IBM Plex Mono',monospace",fontSize:11,color:'#00e5a0' }}>{c.returned_at?.slice(0,16)||'—'}</span></td>
            <td className="td"><Chip label={c.status}/></td>
          </tr>)}
        </tbody>
      </table>
    </div>}

    {modal==='checkout'&&<Modal title="Check Out Asset" sub={`${form.inventory_number} · ${form.epc}`} onClose={()=>setModal(null)}>
      <div style={{ background:'#060b10',border:'1px solid #00e5a030',borderRadius:8,padding:'12px 16px',marginBottom:18 }}>
        <div style={{ fontWeight:700,color:'#e8edf2',fontSize:15,marginBottom:4 }}>{form.asset_name}</div>
        <div style={{ fontSize:12,color:'#3a5060' }}>Facility: {form.facility_name} · Checked out by: <span style={{ color:'#c8d6e0' }}>{profile?.name}</span></div>
      </div>
      <div style={{ display:'grid',gap:14,marginBottom:14 }}>
        <div><Lbl>Checked Out To / Purpose *</Lbl><input className="inp" value={form.checked_out_to||''} placeholder="e.g. Project Alpha, Office Use, Maintenance…" onChange={e=>setForm(f=>({...f,checked_out_to:e.target.value}))} /></div>
        <div><Lbl>Expected Return Date</Lbl><input className="inp" type="date" value={form.expected_return||''} onChange={e=>setForm(f=>({...f,expected_return:e.target.value}))} /></div>
        <div><Lbl>Notes</Lbl><textarea className="inp" style={{ resize:'vertical',minHeight:60 }} value={form.notes||''} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} /></div>
      </div>
      <div style={{ display:'flex',gap:10 }}>
        <button className="btn" style={{ flex:1,background:'none',border:'1px solid #1a2a3a',color:'#607080' }} onClick={()=>setModal(null)}>Cancel</button>
        <button className="btn" style={{ flex:2,background:'#00e5a0',color:'#060b10' }} onClick={doCheckout} disabled={saving}>{saving?'Processing…':'✓ Confirm Check Out'}</button>
      </div>
    </Modal>}

    {returnModal&&<Modal title="Return Asset" sub={`${returnModal.inventory_number} · ${returnModal.asset_name}`} onClose={()=>setReturnModal(null)}>
      <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:20 }}>
        {[['Asset',returnModal.asset_name],['Inventory No.',returnModal.inventory_number],['Checked Out By',returnModal.checked_out_by],['Purpose',returnModal.checked_out_to],['Checked Out At',returnModal.checked_out_at?.slice(0,16)],['Facility',returnModal.facility_name]].map(([k,v])=>(
          <div key={k} style={{ background:'#060b10',border:'1px solid #1a2a3a',borderRadius:8,padding:'10px 14px' }}>
            <div style={{ fontSize:10,color:'#3a5060',textTransform:'uppercase',marginBottom:4 }}>{k}</div>
            <div style={{ fontSize:13,color:'#c8d6e0' }}>{v||'—'}</div>
          </div>
        ))}
      </div>
      <div style={{ display:'flex',gap:10 }}>
        <button className="btn" style={{ flex:1,background:'none',border:'1px solid #1a2a3a',color:'#607080' }} onClick={()=>setReturnModal(null)}>Cancel</button>
        <button className="btn" style={{ flex:2,background:'#5b9cf6',color:'#060b10' }} onClick={()=>doReturn(returnModal)} disabled={saving}>{saving?'Processing…':'↩ Confirm Return'}</button>
      </div>
    </Modal>}
  </div>;
}
